import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { APP_CONFIGS } from 'app/_core/services/app-config.service';

@Injectable()
export class AppConfigGuard {
  canActivate(route: ActivatedRouteSnapshot): boolean {
    const flag = route.data.appFeatureFlag as string;

    if (APP_CONFIGS[flag]) {
      return true;
    }

    return false;
  }
}
